import { isEmpty, removeWhiteSpace } from './strings';
import { undefOrNull } from './objects';
import { snackbar } from '../stores';
export const resetInput = (props) => {
    return Object.assign(props, {
        touched: false,
        touchedTwice: false,
        dirty: false,
        value: undefined,
        error: undefined
    });
};
export const isRequired = (value) => {
    if (Array.isArray(value)) {
        return !!value.length;
    }
    else if (typeof value == 'string') {
        return !undefOrNull(value) && !isEmpty(value);
    }
    else if (typeof value == 'boolean') {
        return value;
    }
    else {
        return !undefOrNull(value);
    }
};
export const hasUppercase = (value) => value.toLowerCase() != value;
export const hasLowercase = (value) => value.toUpperCase() != value;
export const hasMinLength = (value, min) => !!value && removeWhiteSpace(value).length >= min;
export const isSIREN = (value) => {
    value = removeWhiteSpace(value);
    if (value.length != 9 || isNaN(parseInt(value))) {
        return false;
    }
    else {
        // Donc le SIREN est un numérique à 9 chiffres
        let somme = 0;
        let tmp = null;
        for (let cpt = 0; cpt < value.length; cpt++) {
            if (cpt % 2 == 1) {
                const char = value.charAt(cpt);
                const charAsNumber = parseInt(char, 10);
                // Les positions paires : 2ème, 4ème, 6ème et 8ème chiffre
                if (!isNaN(charAsNumber)) {
                    tmp = charAsNumber * 2; // On le multiplie par 2
                }
                if (tmp && tmp > 9) {
                    tmp -= 9;
                } // Si le résultat est supérieur à 9, on lui soustrait 9
            }
            else {
                const charAsNumber = parseInt(value.charAt(cpt), 10);
                if (!isNaN(charAsNumber)) {
                    tmp = charAsNumber;
                }
            }
            somme += tmp ?? 0;
        }
        if (somme % 10 == 0) {
            return true; // Si la somme est un multiple de 10 alors le SIREN est valide
        }
    }
    return false;
};
export const isSIRET = (value) => {
    value = removeWhiteSpace(value);
    if (value.length != 14 || isNaN(parseInt(value))) {
        return false;
    }
    else {
        // Donc le SIRET est un numérique à 14 chiffres
        // Les 9 premiers chiffres sont ceux du SIREN (ou RCS), les 4 suivants
        // correspondent au numéro d'établissement
        // et enfin le dernier chiffre est une clef de LUHN.
        let somme = 0;
        let tmp = null;
        for (let cpt = 0; cpt < value.length; cpt++) {
            if (cpt % 2 == 0) {
                // Les positions impaires : 1er, 3è, 5è, etc...
                const char = value.charAt(cpt);
                const charAsNumber = parseInt(char, 10);
                // Les positions paires : 2ème, 4ème, 6ème et 8ème chiffre
                if (!isNaN(charAsNumber)) {
                    tmp = charAsNumber * 2; // On le multiplie par 2
                }
                if (tmp && tmp > 9) {
                    tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
                }
            }
            else {
                const charAsNumber = parseInt(value.charAt(cpt), 10);
                if (!isNaN(charAsNumber)) {
                    tmp = charAsNumber;
                }
            }
            somme += tmp ?? 0;
        }
        if (somme % 10 == 0) {
            return true; // Si la somme est un multiple de 10 alors le SIRET est valide
        }
    }
    return false;
};
export const hasNumber = (value) => /\d/.test(value);
export const hasSpecialCharacter = (value) => /[`!@#$%^&*()_+\-=\\[\]{};':"|,.<>/?~]/.test(value);
export const requiredRule = (label) => {
    return { label: label, check: isRequired, key: 'required' };
};
export const investAmountRule = (min, max, label) => {
    return {
        label: label,
        check: (v) => !isNaN(v) && v >= min && v <= max
    };
};
export const createFormValidation = (inputsProps, formValidatorsRequiredMessage, formMissingFieldsMessage) => {
    const isFormValid = inputsProps.every((i) => {
        return undefOrNull(i) || !i.validation || i.validation.valid;
    });
    return {
        handleSubmit: (onSubmit) => {
            if (isFormValid) {
                onSubmit();
            }
            else {
                handleFormErrorRequired(inputsProps, formValidatorsRequiredMessage, formMissingFieldsMessage);
            }
        },
        valid: isFormValid
    };
};
export const handleFormErrorRequired = (inputs, formValidatorsRequiredMessage, formMissingFieldsMessage) => {
    let scrollRef;
    inputs.reverse().forEach((i) => {
        if (!i.validation?.valid) {
            i = {
                ...i,
                error: formValidatorsRequiredMessage
            };
            const element = document.getElementById(i.id);
            if (i.ref !== undefined && i.ref?.type === 'file') {
                scrollRef = i.ref;
                scrollRef = element.nextElementSibling;
                scrollRef.style.borderColor = 'red';
            }
            else if (element?.localName === 'select') {
                // On prend l'élément précédent car l'élément récupéré a un display:none qui empêche le scrollIntoView
                scrollRef = element.previousElementSibling;
                const firstChild = scrollRef.firstChild;
                firstChild.style.borderColor = 'red';
            }
            else if (element?.localName === 'label') {
                // On prend l'élément parent car l'élément récupéré a un display:none qui empêche le scrollIntoView
                scrollRef = element.parentElement;
                scrollRef.style.border = 'red';
                scrollRef.style.borderStyle = 'dotted';
                scrollRef.style.borderWidth = '3px';
            }
            else if (element?.localName === 'input') {
                const targetElement = element.previousElementSibling ?? element;
                targetElement.style.border = 'red';
                targetElement.style.borderStyle = 'dotted';
                targetElement.style.borderWidth = '3px';
            }
        }
        else if (i.ref === undefined && document.getElementById(i.id)?.localName === 'select') {
            const redElt = document.getElementById(i.id)?.previousElementSibling;
            const firstChild = redElt?.firstChild;
            if (firstChild !== undefined) {
                firstChild.style.borderColor = 'rgb(187, 187, 187)';
            }
        }
        else if (i.ref === undefined && document.getElementById(i.id)?.localName === 'label') {
            const redElt = document.getElementById(i.id)?.parentElement;
            if (redElt !== undefined) {
                redElt.style.borderStyle = 'none';
            }
        }
        else if (i.ref !== undefined && i.ref.type === 'file') {
            const redElt = document.getElementById(i.id)?.nextElementSibling;
            if (redElt !== undefined) {
                redElt.style.borderColor = 'rgb(187, 187, 187)';
            }
        }
    });
    if (scrollRef) {
        scrollRef.scrollIntoView({
            behavior: 'smooth'
        });
    }
    snackbar.danger(formMissingFieldsMessage);
};
export const escapeXml = (unsafe) => {
    return unsafe.replace(/[<>&'"]/g, (c) => {
        switch (c) {
            case '<':
                return '&lt;';
            case '>':
                return '&gt;';
            case '&':
                return '&amp;';
            case "'":
                return '&apos;';
            case '"':
                return '&quot;';
            default:
                return c;
        }
    });
};
export const addOnePasswordButtonToExcludeRefs = async (excludedRefs) => {
    excludedRefs = [];
    return new Promise((resolve) => {
        setTimeout(() => {
            const webComponent = document.getElementsByTagName('com-1password-button');
            webComponent.length && excludedRefs.push(webComponent[0]);
            resolve(excludedRefs);
        }, 200);
    });
};
